import { useRoutePrefetch } from '@/hooks/useRoutePrefetch';

/**
 * Smart Prefetch Provider
 * Wraps the app to enable automatic route-based prefetching
 */
export const SmartPrefetchProvider = () => {
  useRoutePrefetch();
  return null;
};
